import { render, staticRenderFns } from "./comp_CustomizationFields.vue?vue&type=template&id=0c38844e&scoped=true&"
import script from "./comp_CustomizationFields.vue?vue&type=script&lang=js&"
export * from "./comp_CustomizationFields.vue?vue&type=script&lang=js&"
import style0 from "./comp_CustomizationFields.vue?vue&type=style&index=0&id=0c38844e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38844e",
  null
  
)

export default component.exports